export const iconFontAwesomeAutomotiveCarRear = (
	<i className="fa-solid fa-car-rear"></i>
);
